export interface TragerisikoWerte {
  entschaedigungsgrenze: number | null;
  einzelwert: number | null;
}

export const ENTSCHAEDIGUNGSGRENZE_TRAGERISIKO_UNIT_FACTOR = 1000;

export function isTragerisikoComplete(tragerisiko: TragerisikoWerte): boolean {
  return tragerisiko?.entschaedigungsgrenze != null && tragerisiko?.einzelwert != null;
}

export function getEntschaedigungsgrenzeInEuro(tragerisiko: TragerisikoWerte): number | null {
  return tragerisiko?.entschaedigungsgrenze != null
    ? tragerisiko.entschaedigungsgrenze * ENTSCHAEDIGUNGSGRENZE_TRAGERISIKO_UNIT_FACTOR
    : tragerisiko?.entschaedigungsgrenze;
}
